import React, { useState, useEffect } from "react";

interface ValueLabelProp {
  value?: number;
  children?: React.ReactNode;
}

const ValueLabel: React.FC<ValueLabelProp> = ({ value = 0, children }) => {
  const easeOutExpo = (t: number) => {
    if (t === 1) return 1;
    return 1 - Math.pow(2, -25 * t);
  };

  const useCountUp = (num: number, duration: number) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      let start = Date.now();
      let animationFrame: number;

      const updateCount = () => {
        const elapsedTime = Date.now() - start;
        let progress = Math.min(elapsedTime / duration, 1);

        const slowFactor = Math.log10(num + 1) * 2; 
        if (progress > 0.8) {
          progress = 0.8 + (progress - 0.8) / (2 * slowFactor);
        }
        if (progress > 0.9) {
          progress = 0.9 + Math.pow(progress - 0.9, 2) / slowFactor; 
        }

        const easedProgress = easeOutExpo(progress); 
        setCount(Math.round(num * easedProgress));

        if (progress < 1) {
          animationFrame = requestAnimationFrame(updateCount);
        }
      };

      updateCount(); 

      return () => cancelAnimationFrame(animationFrame); 
    }, [num, duration]);

    return count;
  };

  return (
    <div className="stat-value d-flex align-items-center gap-2">
      {useCountUp(value, 3000).toLocaleString()} 
      {children}
    </div>
  );
};

export default ValueLabel;
